/* Package JSON Import will be here */
import React from "react";
import { useSelector } from "react-redux";
/* Package JSON Import will be here */

/* Project Import will be here */
import UserNameLogin from "./UserNameForm";
import MobileNumberForm from "./MobileNumberForm";
import PasswordForm from "./PasswordForm";
import ChangePasswordForm from "./ChangePasswordForm";
/* Project Import will be here */

const NewLoginFormContainer = (props) => {
  const { userLoginAtFirstTime, showPasswordForm, isLoginWithPassword } = useSelector((state) => ({
    userLoginAtFirstTime: state.session.userLoginAtFirstTime,
    showPasswordForm: state.session.showPasswordForm,
    isLoginWithPassword: state.session.isLoginWithPassword,
  }));

  if (showPasswordForm)
    return <PasswordForm />;
  else if (userLoginAtFirstTime && !isLoginWithPassword)
    return <MobileNumberForm />;
  else if (userLoginAtFirstTime && isLoginWithPassword)
    return <ChangePasswordForm />;
  else
    return <UserNameLogin />;
};

export default NewLoginFormContainer;